(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-v4-pdp"]) return;
  try {
    
  (function () {
    if (!document.querySelector(".v4-pdp")) return;
    var H = ".v4-pdp__thumbs, .v4-pdp__thumbs-wrap, .cross-sells__track, .cross-sells__slider, .cross-sells__scroller, .v4-reviews__scroller, .benefit_marquee_wrap, .fb-def-pairs__grid, [data-fb-pairs-track], [data-h-scroll]";
    function ok(n) { return n && n.closest && n.closest(H); }
    function lock() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (window.scrollX || document.documentElement.scrollLeft) window.scrollTo(0, y);
    }
    lock();
    window.addEventListener("scroll", lock, { passive: true });
    window.addEventListener("pageshow", lock);
    var tx = 0, ty = 0, inScroll = false;
    document.addEventListener("touchstart", function (e) {
      if (e.touches.length === 1) {
        tx = e.touches[0].clientX;
        ty = e.touches[0].clientY;
        inScroll = ok(e.target);
      }
    }, { passive: true, capture: true });
    document.addEventListener("touchmove", function (e) {
      if (e.touches.length !== 1 || inScroll || ok(e.target)) return;
      var dx = e.touches[0].clientX - tx, dy = e.touches[0].clientY - ty;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 4) e.preventDefault();
    }, { passive: false, capture: true });
    document.addEventListener("touchend", function () { inScroll = false; }, { passive: true, capture: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
